import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { getTherapies, deleteTherapy, updateTherapiesPagination } from '../../store/actions/therapy/therapy_action';
import { makeStyles, Paper, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import TablePagination from '../ui_components/table_pagination';
import { REACT_ROUTES } from '../../constants/react_routes';
import history from '../../services/history';
import ActionsComponent from '../ui_components/actions_component';

const useStyles = makeStyles((theme) => ({
	paper: {
        width: '100%',
        marginTop: theme.spacing(3),
        overflowX: 'auto'
    },
    table: {
        minWidth: 500
    }
}));

const TherapiesTable = ({ therapies: { collection, totalCount, page, rowsPerPage, filters } }) => {
    const { paper, table, tableRow } = useStyles();
    const dispatch = useDispatch();

    useEffect(() => {
        if (!collection.length) {
            dispatch(getTherapies({ page, rowsPerPage, filters }));
        }
    }, []);

    const handleClick = (uuid) => {
        history.push(`${REACT_ROUTES.THERAPY}/${uuid}`);
    }

    const handleDeleteTherapy = (uuid) => {
        dispatch(deleteTherapy(uuid))
            .then(() => dispatch(getTherapies({ page, rowsPerPage, filters })));
    }

    return (
        <Paper className={paper}>
            <Table aria-label="table" className={table}>
                <TableHead>
                    <TableRow>
                        <TableCell align="center">Naziv</TableCell>
                        <TableCell align="center">Doza</TableCell>
                        <TableCell align="right">Akcije</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {collection.map(({ uuid, name, dose, deletable }, index) =>
                        <TableRow hover key={index} className={tableRow}>
                            <TableCell align="center">{ name }</TableCell>
                            <TableCell align="center">{ dose }</TableCell>
                            <TableCell align="right">
                                <ActionsComponent
                                    handleEdit={() => handleClick(uuid)}
                                    handleDelete={() => handleDeleteTherapy(uuid)}
                                    deletable={deletable}
                                    label="terapiju"
                                />
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
                <TablePagination
                    page={page}
                    count={totalCount}
                    rowsPerPage={rowsPerPage}
                    filters={filters}
                    updatePagination={updateTherapiesPagination}
                 />
            </Table>
        </Paper>
    )
}

TherapiesTable.propTypes = {
    therapies: PropTypes.object
}

const mapStateToProps = (state) => ({
    therapies: state.therapies
});

export default connect(mapStateToProps)(TherapiesTable);
